import { FormControl, Grid } from '@mui/material'
import { CustomAutocomplete, LinearLoading } from 'common'

export const FieldManagementType = (props) => {

    const {
        formState,
        onSelectSearchChange,
        FetchData,
        readOnly
    } = props

    const { fetchAllContracts, fetchAllTypeManagements } = FetchData
    const { loadingFetchContracts } = fetchAllContracts
    const { typeManagements, loadingFetchTypeManagements } = fetchAllTypeManagements

    return (
        <>
            {(loadingFetchTypeManagements || loadingFetchContracts) && <LinearLoading />}
            {(!loadingFetchTypeManagements && !loadingFetchContracts) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                        <FormControl fullWidth>
                            <label htmlFor="idgestiontipo"> * Tipo de Gestion</label>
                            <CustomAutocomplete
                                customId="idgestiontipo"
                                customName="idgestiontipo"
                                customValue={formState.idgestiontipo}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idgestiontipo', value: value.value }  })}
                                customPlaceholder='Seleccione una gestion'
                                customOptions={
                                    typeManagements.map(({ idgestiontipo, prefijo, descripcion }) => ({
                                    value: idgestiontipo,
                                    name: (prefijo+' - '+descripcion)
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={readOnly}
                            />
                        </FormControl>
                    </Grid> 
                </Grid>
            )}
        </>
    )
}
